// mutations.js

export default {
    updateBrandList(state, brands){
        state.brandList = brands
    }
};
